import * as RadixTooltip from '@radix-ui/react-tooltip'
import styles from './Tooltip.module.css'

interface TooltipProps {
    children: React.ReactElement
    content: string
    side?: 'top' | 'right' | 'bottom' | 'left'
}

const Tooltip = ({ children, content, side = 'right' }: TooltipProps) => {
    return (
        <RadixTooltip.Root delayDuration={200}>
            <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
            <RadixTooltip.Portal>
                <RadixTooltip.Content
                    side={side}
                    sideOffset={5}
                    className={styles.tooltipContent}
                >
                    {content}
                </RadixTooltip.Content>
            </RadixTooltip.Portal>
        </RadixTooltip.Root>
    )
}

export default Tooltip
